module.exports = __webpack_public_path__ + "static/media/zolaicons.30a661bc.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/build/assets/fonts/zolaicons.eot?34023347
// module id = 155
// module chunks = 44